import { IApplicationState } from '../../types/redux';
import { ESearchQueryActionType, TSearchQueryActions } from '../../actions/searchQuery';

export function searchQueryReducer(
  state: IApplicationState['searchQuery'] = '',
  action: TSearchQueryActions,
): IApplicationState['searchQuery'] {
  switch (action.type) {
    case ESearchQueryActionType.SetSearchQuery:
      return action.payload;
    default:
      return state;
  }
}
